import { render, staticRenderFns } from "./MegaNavLink.vue?vue&type=template&id=b346e7e4&scoped=true&"
import script from "./MegaNavLink.vue?vue&type=script&lang=js&"
export * from "./MegaNavLink.vue?vue&type=script&lang=js&"
import style0 from "./MegaNavLink.vue?vue&type=style&index=0&id=b346e7e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b346e7e4",
  null
  
)

export default component.exports